module.exports = __webpack_public_path__ + "static/media/16UNODC33.97a654b0.jpg";